const DATAYEARSELECT = [];
const currentYear = new Date().getFullYear();

for (let i = currentYear; i >= 1900; i -= 1) {
  DATAYEARSELECT.push({ label: i.toString(), value: i.toString() });
}

export default DATAYEARSELECT;
